import { UserRole } from '@/types';

export type EffectiveRole = 'admin' | 'manager' | 'engineer';

const ADMIN_EQUIVALENTS = new Set<string>(['admin']);
const MANAGER_EQUIVALENTS = new Set<string>([
  'manager',
  'team_lead',
  'project_manager',
  'department_head',
]);
const ENGINEER_EQUIVALENTS = new Set<string>([
  'engineer',
  'individual_contributor',
]);

export const normalizeRole = (role?: UserRole | string | null): EffectiveRole => {
  if (!role) return 'engineer';
  if (ADMIN_EQUIVALENTS.has(role)) return 'admin';
  if (MANAGER_EQUIVALENTS.has(role)) return 'manager';
  if (ENGINEER_EQUIVALENTS.has(role)) return 'engineer';
  return 'engineer';
};

export const isAdminOrManager = (role?: UserRole | string | null): boolean => {
  const effective = normalizeRole(role);
  return effective === 'admin' || effective === 'manager';
};
